import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import auth0 from "auth0-js";

export function useAuthErrorMessage() {
  const [error, setError] = useState();
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    setError(query.get("error_description"));
  }, [location.search]);

  return [error, setError];
}

export function useAuthSuccessMessage() {
  const [success, setSuccess] = useState();
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    setSuccess(query.get("success_description"));
  }, [location.search]);

  return [success, setSuccess];
}

export function logout() {
  localStorage.removeItem('remember_me');
  localStorage.removeItem('session');

  sessionStorage.setItem("logout_url", window.location.pathname + window.location.search)
  return webAuth.logout({
    returnTo: `${window.location.origin}`,
    clientID: process.env.REACT_APP_AUTH0_CLIENT_ID
  })
}

export const webAuth = new auth0.WebAuth({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  scope: "read:current_user openid profile update:current_user_metadata",
  responseType: "token id_token",
  redirectUri: window.location.origin,
});

